module.exports = {"TXTWCL_There_are_price_updates":{"id":"TXTWCL_There_are_price_updates","defaultMessage":"Ci sono delle quote aggiornate"}}